import ApolloClient from 'apollo-boost'
import VueApollo from 'vue-apollo'

const apolloClient = new ApolloClient({
  uri: `${process.env.VUE_APP_API}/api/v2/graphql`
})

export const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})
